import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85e3cbb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app-main" }
const _hoisted_2 = { class: "body" }

import { ref, onMounted } from "vue";
import MainNavbar from "@/components/MainNavbar.vue";
import Footer from "../components/Footer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarLayout',
  setup(__props) {

const windowWidth = ref(1920);
onMounted(async () => {
  windowWidth.value = window.innerWidth;

  window.addEventListener("resize", () => {
    windowWidth.value = window.innerWidth;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(MainNavbar, { class: "navbar" })
    ]),
    _createElementVNode("section", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(Footer)
  ]))
}
}

})